import { render, staticRenderFns } from "./academic_schdual_refereesystem_group_promote_rooms.vue?vue&type=template&id=33981be8&scoped=true&"
import script from "./academic_schdual_refereesystem_group_promote_rooms.vue?vue&type=script&lang=js&"
export * from "./academic_schdual_refereesystem_group_promote_rooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33981be8",
  null
  
)

export default component.exports